import { connectRange } from 'react-instantsearch-dom';
import styled from "styled-components";

import Select from 'react-select'

const RangeDivider = styled.div`
display: inline-flex;
position: relative;
top: 1px;
`;

const RangeDividerIcon = styled.div`
color: #2c271c;
opacity: .3;
padding-right: 15px;
padding-left: 15px;
font-size: 20px;
`;

const SelectRange = styled.div`
max-width: 88px;
display: -webkit-inline-box;
display: -ms-inline-flexbox;
display: inline-flex;
`;


const inputRangeValues = new Array(18).fill().map((e,i) => {
  let label = (i === 17) ? '18+' : i + 1
   return {idx: i + 1, label: label, value: i + 1}
});

const inputMaxRangeValues = new Array(18).fill().map((e,i) => {
  let label = (i === 17) ? '18+' : i + 1
  let value = (i === 17) ? 99 : i + 1
   return {idx: i + 1, label: label, value: value}
});

const RangeInput = ({ currentRefinement, min, max, precision, refine }) => {

  const range = (min, max) => [...Array(max - min + 1).keys()].map(i => i + min);

  //console.log('currentRefinement RANGE', currentRefinement);

  let initialMaxValue = inputRangeValues[inputRangeValues.length - 1];
  let initalMinValue = inputRangeValues[0];
  let minRangeValues = inputRangeValues;
  let maxRangeValues = inputMaxRangeValues;

  if (currentRefinement) {
    if (currentRefinement.min) {
      let valueMin = inputRangeValues.find(i => i.value === currentRefinement.min);
      if (valueMin) initalMinValue = valueMin;
      //maxRangeValues =
    }

    if (currentRefinement.max) {
      let valueMax = inputRangeValues.find(i => i.value === currentRefinement.max);
      if (valueMax) initialMaxValue = valueMax;
      //minRangeValues =
    }

  }

  const customStyles = {
    indicatorSeparator: () => ({
      display: 'none;'
    })
  }

  return(

  <div>
  <SelectRange>
  <Select styles={customStyles} menuPlacement="top" options={minRangeValues} value={initalMinValue} onChange={selectedOption =>
    refine({
      ...currentRefinement,
      min: selectedOption.value,
    })
  }/>
  </SelectRange>
  <RangeDivider><RangeDividerIcon>—</RangeDividerIcon></RangeDivider>
  <SelectRange>
  <Select styles={customStyles} menuPlacement="top" options={maxRangeValues} value={initialMaxValue} onChange={selectedOption =>
    refine({
      ...currentRefinement,
      max: selectedOption.value,
    })
  }/>
  </SelectRange>
  </div>
);
}

const SelectOptionRefinement = connectRange(RangeInput);
export default SelectOptionRefinement;
